import React from 'react';
import { Link } from 'react-router-dom';
import { CircleSlash, ArrowLeft } from 'lucide-react';
import ADMIN_PATHS from '../ADMIN_PATHS';

const cx = (...arr) => arr.filter(Boolean).join(' ');

const Card = ({ children, className }) => (
  <div className={cx('bg-white border border-slate-200 rounded-2xl', className)}>{children}</div>
);

const SectionHead = ({ title, subtitle, right }) => (
  <div className="flex items-start justify-between gap-3">
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        <span className="h-4 w-[3px] rounded-full bg-primary" aria-hidden="true" />
        <h2 className="text-base md:text-lg font-black tracking-tight text-slate-900">{title}</h2>
      </div>
      {subtitle ? <p className="mt-1 text-sm text-slate-500">{subtitle}</p> : null}
    </div>
    {right ? <div className="shrink-0">{right}</div> : null}
  </div>
);

const ManualOrder = () => (
  <div className="p-6 space-y-6">
    <SectionHead
      title="Manual Order"
      subtitle="Orders can only originate from customer checkout with a verified payment session."
    />

    <Card className="p-8">
      <div className="mx-auto max-w-xl text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 text-slate-500">
          <CircleSlash className="h-6 w-6" />
        </div>
        <h3 className="mt-4 text-sm font-black tracking-tight text-slate-900">
          Manual order creation is not available
        </h3>
        <p className="mt-2 text-sm text-slate-600">
          There is no backend endpoint that can complete a manual order: paid orders must be created
          through customer checkout and verified by a payment session, so an admin-created order
          could never reach payment, approval, or AliExpress forwarding.
        </p>
        <p className="mt-2 text-sm text-slate-600">
          To act on an existing order (approve, forward to AliExpress, cancel), open it from the
          order list.
        </p>
        <div className="mt-5 flex items-center justify-center gap-2">
          <Link
            to={ADMIN_PATHS.ORDERS_PAGES.ALL}
            className="inline-flex items-center gap-2 rounded-xl bg-primary px-4 py-2 text-sm font-black text-white hover:bg-primary/90"
          >
            All orders
          </Link>
          <Link
            to={ADMIN_PATHS.ORDERS_PAGES.RECOVERY}
            className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-black text-slate-700 hover:bg-slate-50"
          >
            <ArrowLeft className="w-4 h-4" />
            Unpaid queue
          </Link>
        </div>
      </div>
    </Card>
  </div>
);

export default ManualOrder;
